export const submissionLoadingScreens = [
    { translationKey: 'submissionLoading.searching_providers', seconds: 5 },
    { translationKey: 'submissionLoading.do_not_refresh', seconds: 5 },
    { translationKey: 'submissionLoading.searching_providers', seconds: 10 },
    { translationKey: 'submissionLoading.evaluating_options', seconds: 5 },
    { translationKey: 'submissionLoading.do_not_refresh', seconds: 15 },
    { translationKey: 'submissionLoading.evaluating_options', seconds: 15 },
    { translationKey: 'submissionLoading.do_not_refresh', seconds: 10 },
    { translationKey: 'submissionLoading.almost_there', seconds: 10 },
    { translationKey: 'submissionLoading.do_not_refresh', seconds: 10 },
    { translationKey: 'submissionLoading.do_not_leave', seconds: 15 },
    { translationKey: 'submissionLoading.options_available', seconds: 20 },
];

export const submissionLoadingScreenInterval = 4;
